import React, { useState } from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import DeviceKitplayForm from '@modules/listKitplayDevice/DeviceKitplayForm';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

const message = defineMessages({
    objectName: 'Device kitplay',
});

const DeviceChildSavePage = () => {
    const translate = useTranslate();
    const params = useParams();

    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('deviceId');
    const deviceName = queryParams.get('deviceName');
    const path = `?deviceId=${deviceId}&deviceName=${deviceName}`;

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.kitplayDevice.getById,
            create: apiConfig.printer.create,
            update: apiConfig.printer.update,
        },
        options: {
            getListUrl: generatePath(routes.DeviceTab.path, { customerId: params.customerId }) + path,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    parentId: deviceId,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code ?? err.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(translate.formatMessage(errorMessage), translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    const pageTitle = isEditing
        ? `${translate.formatMessage(commonMessage.edit)} ${translate.formatMessage(message.objectName)}`
        : `${translate.formatMessage(commonMessage.create)} ${translate.formatMessage(message.objectName)}`;

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.managerKitplay),
                    path: routes.listKitPlayDevicePage.path,
                },
                {
                    breadcrumbName: deviceName,
                    path: generatePath(routes.DeviceTab.path, { customerId: params.customerId }) + location.search,
                },
                { breadcrumbName: pageTitle },
            ]}
            title={pageTitle}
            loading={loading}
        >
            <DeviceKitplayForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default DeviceChildSavePage;
